import { AdminIndexTable } from "../components/AdminIndexTable";
import { Logger } from "../../utils/Logger";

const CTRL_TAG = "AdminWorkServiceController";

function bindAutoSlug(scope: HTMLElement): void {
    const titleInput = scope.querySelector<HTMLInputElement>("[data-ws-title]");
    const slugInput = scope.querySelector<HTMLInputElement>("[data-ws-slug]");
    if (!titleInput || !slugInput) return;

    let userEditedSlug = false;

    slugInput.addEventListener("input", () => {
        userEditedSlug = slugInput.value.trim() !== "";
    });

    titleInput.addEventListener("input", () => {
        if (userEditedSlug) return;
        slugInput.value = titleInput.value
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-_]/g, "")
            .replace(/-+/g, "-")
            .replace(/^-|-$/g, "");
    });
}

export const AdminWorkServiceController = {
    index(): void {
        Logger.debug(`${CTRL_TAG}.index`);
        const page = document.querySelector<HTMLElement>(".admin-work-services");
        if (!page) return;
        bindAutoSlug(page);
        new AdminIndexTable({ pageSelector: ".admin-work-services" }).init();
    },
};
